// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClockCircleFilledSvg from "@fishx/icons-svg/es/asn/ClockCircleFilled";
import FishxIcon from '../components/FishxIcon';

var ClockCircleFilled = function ClockCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleFilledSvg
  }));
};

ClockCircleFilled.displayName = 'ClockCircleFilled';
export default React.forwardRef(ClockCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ClockCircleFilled.js
// module id = 2228
// module chunks = 0